import { render, staticRenderFns } from "./ScoringFormulaSave.vue?vue&type=template&id=acf84400&"
import script from "./ScoringFormulaSave.vue?vue&type=script&lang=js&"
export * from "./ScoringFormulaSave.vue?vue&type=script&lang=js&"
import style0 from "./ScoringFormulaSave.vue?vue&type=style&index=0&id=acf84400&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports